export const STEPS_HISTORY_PENSION = [
  {
    question: "¿Deseas pago preliminar?",
    paragraph:
      "Este es un <strong>pago adelantado y provisorio que puedes solicitar mientras eliges una modalidad de pensión y se calcula tu pensión definitiva.</strong> Es decir, estos pagos se realizarán desde la fecha en que haces la solicitud de pensión y hasta la selección de modalidad. En el caso de que te pensiones sin derecho a seleccionar la modalidad, el período de trámite es aquel entre la solicitud de pensión y la emisión de la ficha de cálculo del Retiro Programado.",
    controlName: "preliminaryPayment",
  },
  {
    question: "¿Deseas recibir el pago de tu pensión de manera retroactiva?",
    paragraph:
      "Al solicitar tu pensión puedes comenzar a recibir el pago desde la fecha en que haces la solicitud o al cumplir la edad legal para pensionarte, según cuál de estas fechas sea posterior.<br><br>El pago se hará una vez seleccionada la modalidad. Si eliges Retiro Programado puedes recibir el pago desde que firmas el formulario de selección de modalidad, mientras si seleccionas Renta Vitalicia el pago se realiza desde el mes que se transfiere la prima a la Compañía de Seguros.",
    controlName: "pagoRetroactivo",
  },
  {
    question: "¿Solicitas Pensión Garantizada Universal - PGU?",
    paragraph:
      "Este es un beneficio donde el estado entregará un monto para todas las personas mayores de 65 años que pertenezcan al 90% de las familias más vulnerables del país y que sustituye la Pensión Básica Solidaria (PBS). El monto se reajusta anualmente por el IPC.",
    controlName: "pgu",
  },
  {
    question:
      "¿Deseas que tu pensión se ajuste a 2UF? En caso de el monto resulte inferior a éste.",
    paragraph:
      "Si no cumples con los requisitos para acceder a la PGU, puedes optar por retirar un monto de pensión ajustado a las 2 UF, si es que el monto de tu pensión calculada fuera inferior.<br><br>La PGU y el ajuste a las 2 UF son incompatibles, por lo tanto, no corresponde el ajuste de la pensión.",
    controlName: "threeuf",
  },
  {
    question: "¿Solicitas el cálculo del Excedente de Libre Disposición?",
    paragraph:
      "Es una parte de tus ahorros que puede ser retirado siempre y cuando tengas a lo menos 10 años de afiliación en cualquier sistema previsional y si tus fondos previsionales te permitan obtener una pensión al menos igual o mayor al 70% del promedio de tus remuneraciones y mayor o igual a 12 UF de cuál sea mayor.",
    controlName: "free",
  },
  {
    question: "¿Deseas congelar tus saldos?",
    paragraph:
      "Esto significa que <strong>tus ahorros dejarán de ser invertidos en los multifondos</strong>. Con esto, podrías dejar de ganar como perder, por lo tanto, es importante que antes de solicitarlo te asesores sobre los valores cuota en la actualidad. Al congelar los saldos, tu dinero es traspasado a una Cuenta Corriente del Fondo de Pensiones. Puedes solicitarlo desde que ingresas tu trámite de pensión hasta que seleccionas la modalidad de pensión o firmas el desistimiento del trámite.",
    controlName: "freezenBalances",
  },
  {
    question: '¿Transferirás fondos...?',
    controlName: 'transferFunds',
    addonType: 'editable-amount'
  },
];
